<template>
  <com-page>
    <com-search :columns="searchColumn" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleExport">导出</el-button>
        <el-button type="primary" @click="handleAddPartner">{{
          activeName === '0' ? '添加合伙人' : '添加商家'
        }}</el-button>
      </template>
    </com-search>
    <com-card>
      <div class="flex items-center justify-between mb-15px">
        <div class="flex items-start mb-5px">
          <h4 class="mt-12px">角色</h4>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.label"
              :name="item.value"
              v-for="item in statusTag"
              :key="item.value"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <com-table
        :columns="columns"
        :api="api"
        ref="tableRef"
        v-if="activeName == '0'"
        :defaultParams="{ type: 1 }"
      >
        <template #status="row">
          <el-switch
            v-model="row.data.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatus(row.data)"
          >
          </el-switch>
        </template>
        <template #operation="row">
          <el-button type="primary" @click="handleCheck(row.data)" size="mini">查看</el-button>
          <el-button type="primary" @click="handleEdit(row.data)" size="mini">编辑</el-button>
          <el-button type="danger " @click="handleDel(row.data)" class="mb-5rpx" size="mini"
            >删除</el-button
          >
        </template>
      </com-table>
      <com-business-table v-if="activeName == '1'" ref="businessRef"></com-business-table>
    </com-card>
    <the-add-partners ref="partnerRef" @success="update"></the-add-partners>
  </com-page>
</template>

<script>
import { partnersListApi, delPartnerApi, parentsStatusApi, partnersLevelApi } from '@/api/partners'
import { listApi as businessList } from '@/api/business'
import { exportExcel } from '@/utils/index'
import { formatDate } from '@/filters'
import theAddPartners from './components/the-add-partners'

export default {
  components: { theAddPartners },
  data() {
    return {
      api: partnersListApi,
      searchColumn: [],
      partnerSearchColumn: [
        {
          label: '合伙人名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '手机号',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'select',
          option: [
            {
              label: '正常',
              value: 1
            },
            {
              label: '冻结',
              value: 0
            }
          ]
        },
        {
          label: '合伙人等级',
          prop: 'level',
          type: 'select',
          option: []
        },
        {
          label: '地区',
          prop: 'area',
          type: 'region'
        }
      ],
      businessSearchColumn: [
        {
          label: '商家名称',
          prop: 'businessName',
          type: 'input'
        },
        {
          label: '联系人',
          prop: 'name',
          type: 'input'
        },
        {
          label: '联系电话',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'select',
          option: [
            {
              label: '正常',
              value: 1
            },
            {
              label: '冻结',
              value: 0
            }
          ]
        }
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      },
      columns: [
        {
          label: '合伙人编号',
          prop: 'number',
          minWidth: '180'
        },
        {
          label: '合伙人姓名',
          prop: 'name',
          minWidth: '180'
        },
        {
          label: '手机号',
          prop: 'phone',
          minWidth: '150'
        },
        {
          label: '身份证号',
          prop: 'idCard',
          auto: true
        },
        {
          label: '合伙人等级',
          prop: 'levelName',
          minWidth: '150'
        },
        {
          label: '投资金额',
          prop: 'invest',
          auto: true
        },
        {
          label: '投资地区',
          prop: 'investRegionName',
          auto: true
        },
        {
          label: '关联网点数',
          prop: 'storeCount'
        },
        {
          label: '设备数',
          prop: 'deviceCount'
        },
        {
          label: '设备收益',
          prop: 'totalIncome'
        },
        {
          label: '订单量',
          prop: 'orderCount'
        },
        {
          label: '钱包余额',
          prop: 'wallet'
        },
        {
          label: '状态',
          prop: 'status',
          type: 'slot',
          slotName: 'status'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          minWidth: '180',
          slotName: 'operation',
          fixed: 'right'
        }
      ],
      activeName: '0',
      statusTag: [
        {
          label: '合伙人',
          value: '0'
        },
        {
          label: '商家',
          value: '1'
        }
      ]
    }
  },
  created() {
    this.getLevel()
  },
  methods: {
    getLevel() {
      partnersLevelApi('PARTNER_LEVEL').then((res) => {
        const { value } = res.data.setting
        const partnerList = JSON.parse(value)
        this.searchColumn.map((item) => {
          if (item.prop === 'level') {
            item.option = partnerList.map((child) => {
              child.value = child.code
              child.label = child.name
              return child
            })
          }
          return item
        })
        console.log('res合伙人等级 :>> ', partnerList)
      })
    },
    handleSearch(e) {
      if (e.area && e.area.length) {
        e.area = e.area.at(-1)
      }
      const params = {
        ...e
      }
      this.exportQuery = { pageIndex: 1, pageSize: 10000, ...params }

      if (this.activeName === '0') {
        if (params.level !== 'STORE') {
          params.investRegion = params.area
          delete params.area
        }
        this.$refs.tableRef.handleSearch(params)
        return
      }
      this.$refs.businessRef.search(params)
    },
    update() {
      this.$refs.tableRef.getList()
    },
    handleAddPartner() {
      if (this.activeName === '0') {
        const param = {
          type: 'created'
        }
        this.$refs.partnerRef.open(param)
        return
      }

      this.$refs.businessRef.created()
    },
    handleCheck(row) {
      const params = {
        row
      }
      this.$router.push({ name: 'partners-detail', params })
    },
    handleDel(row) {
      this.$confirm('此操作将永久删除该合伙人, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            code: row.code
          }
          delPartnerApi(param).then(() => {
            this.$refs.tableRef.getList()
          })
        })
        .catch(() => {})
    },
    handleStatus(val) {
      const param = {
        status: val.status,
        code: val.code
      }
      parentsStatusApi(param).then(() => {
        this.update()
      })
    },
    handleEdit(row) {
      const param = {
        type: 'edit',
        row
      }
      this.$refs.partnerRef.open(param)
    },
    exportPartner() {
      this.$message.info('请稍等,正在导出...')
      partnersListApi(this.exportQuery).then((res) => {
        const { records } = res.data
        // eslint-disable-next-line prefer-const
        let newArr = []
        records.forEach((item) => {
          const params = {
            合伙人编号: item.number,
            合伙人姓名: item.name,
            手机号码: item.phone,
            身份证号: item.idCard,
            合伙人等级: item.levelName,
            投资金额: item.invest,
            投资地区: item.investRegionName,
            关联网点数: item.storeCount,
            设备数: item.deviceCount,
            设备收益: item.totalIncome,
            订单量: item.orderCount,
            钱包余额: item.wallet,
            状态: item.status === 1 ? '启用' : '停用'
          }
          newArr.push(params)
        })
        exportExcel(newArr, '合伙人列表')
      })
    },
    exportBusiness() {
      this.$message.info('请稍等,正在导出...')
      businessList(this.exportQuery).then((res) => {
        const { records } = res.data
        // eslint-disable-next-line prefer-const
        let newArr = []
        records.forEach((item) => {
          const params = {
            商家编号: item.number,
            商家名称: item.name,
            商家地址: item.address,
            联系人: item.contact,
            联系电话: item.phone,
            关联网点数: item.storeCount,
            设备数: item.deviceCount,
            订单量: item.orderCount,
            分成收入: item.divideIncome,
            状态: item.status === 1 ? '正常' : '冻结',
            创建时间: formatDate(item.createTime)
          }
          newArr.push(params)
        })
        exportExcel(newArr, '商家列表')
      })
    },
    handleClick() {
      console.log('2233 :>> ')
    },
    handleExport() {
      if (this.activeName === '0') {
        this.exportPartner()
        return
      }
      this.exportBusiness()
    }
  },

  watch: {
    activeName: {
      handler(val) {
        if (val === '0') {
          this.searchColumn = this.partnerSearchColumn
        }
        if (val === '1') {
          this.searchColumn = this.businessSearchColumn
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
